import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTDialog {
    /* @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;
    }

    $onInit() {
        this.$timeout(() => {
            this.$modalDialog = $(`#${this.dialogOptions.modalDialogId}`);

            this.subscribeToEvents();
            this.showModal();
        }, 10);
    }

    subscribeToEvents() {
        this.$modalDialog.on('hidden.bs.modal', () => {
            this.onCloseButtonClick();
            this.$modalBackdropContainer.remove();
            this.onClose();
        });
    }

    showModal() {
        const customZIndex = this.dialogOptions.customZIndex;

        if (customZIndex) {
            this.$modalDialog.css('z-index', customZIndex);
        }

        this.$modalDialog.modal('show');

        this.$timeout(() => {
            const $modalBackdrops = $('.modal-backdrop');

            if ($modalBackdrops.length !== 0) {
                const $modalBackdropContainer = $($modalBackdrops[$modalBackdrops.length - 1]);
                const $modalDialogZIndex = parseInt(this.$modalDialog.css('z-index'));

                $modalBackdropContainer.css('z-index', $modalDialogZIndex - 1);
                this.$modalBackdropContainer = $modalBackdropContainer;
            }
        });
    }

    onCloseButtonClick() {
        this.dialogOptions.onClose();
        this.closeModal();
    }

    handleButtonClick(button) {
        button.onClick();
        this.closeModal();
    }

    closeModal() {
        this.$modalDialog.modal('hide');
    }

    $onDestroy() {
        this.unsubscribeFromEvents();
    }

    unsubscribeFromEvents() {
        this.$modalDialog.off('hidden.bs.modal');
    }
}

export const TFTDialogConfiguration = {
    template,
    controller: TFTDialog,
    bindings: {
        dialogOptions: '<',
        onClose: '&',
    },
    controllerAs: 'dialogCtrl',
};

angular.module('TALENYA-FE').component('tftDialog', TFTDialogConfiguration);
